import { MenuItem, Select, TextField, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

interface DropdownProps {
  field: any;
  options: { id: string; label: string }[];
  label: string;
  error?: string;
  searchable?: boolean;
  searchPlaceholder?: string;
}

const Dropdown = ({
  field,
  options,
  label,
  error,
  searchable = false,
  searchPlaceholder = "Buscar...",
}: DropdownProps) => {
  const [searchValue, setSearchValue] = useState("");
  const menuPaperRef = useRef<HTMLDivElement | null>(null);

  const filteredOptions = searchable
    ? options.filter((option) =>
        option.label.toLowerCase().includes(searchValue.toLowerCase()),
      )
    : options;

  useEffect(() => {
    if (menuPaperRef.current) {
      menuPaperRef.current.scrollTop = 0;
    }
  }, [searchValue]);

  return (
    <>
      <Select
        {...field}
        label={label}
        sx={{ width: "100%" }}
        onClose={() => setSearchValue("")}
        MenuProps={{
          PaperProps: {
            ref: menuPaperRef,
            style: {
              maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            },
          },
        }}
      >
        {searchable && (
          <MenuItem
            disableRipple
            onKeyDown={(e) => e.stopPropagation()}
            sx={{
              position: "sticky",
              top: 0,
              backgroundColor: "background.paper",
              zIndex: 1,
            }}
          >
            <TextField
              size="small"
              placeholder={searchPlaceholder}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              fullWidth
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
            />
          </MenuItem>
        )}
        {filteredOptions.map((role) => (
          <MenuItem key={role.id} value={role.id}>
            {role.label}
          </MenuItem>
        ))}
      </Select>

      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{
          opacity: error ? 1 : 0,
          height: error ? "auto" : 0,
        }}
        transition={{
          duration: 0.3,
          ease: "easeInOut",
        }}
        style={{ overflow: "hidden" }}
      >
        {error && (
          <Typography
            variant="caption"
            color="error"
            sx={{
              color: "red",
              display: "block",
              mt: 0.5,
            }}
          >
            {error}
          </Typography>
        )}
      </motion.div>
    </>
  );
};

export default Dropdown;
